// Profile of Alina Tselinina, Ukrainian. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina — інженерка програмного забезпечення з досвідом в інженерії даних, прикладній математиці та машинному навчанні; нині працює над застосунками на основі ШІ та агентними системами. Має досвід створення API та конвеєрів даних, модернізації застосунків шляхом міграції до хмари та розробки сервісів на основі ML. Зосереджується на поєднанні LLM і ШІ-агентів із надійними програмними системами за допомогою структурованих робочих процесів, інтеграцій, тестування та ітеративного оцінювання.',
  imageAlt: 'Портрет Alina Tselinina',
  personal: {
    languages: 'Англійська, польська',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Навчання: фінансова та актуарна математика',
      institution: 'Університет імені Адама Міцкевича, Познань',
      degree: 'Ступінь: магістр'
    },
    {
      period: '2009 - 2014',
      field: 'Навчання: математика',
      institution: 'Білоруський державний університет, Мінськ',
      degree: 'Ступінь: бакалавр'
    }
  ],
  skills: [
    {
      title: 'Програмування',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'ШІ та LLM',
      description: 'Claude, MCP, ШІ-агенти, адаптація LLM, навчання та оцінювання моделей'
    },
    {
      title: 'Хмара та дані',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Фреймворки та API',
      description: 'FastAPI, Flask, Shiny, REST API, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Інженерія даних і DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Бази даних і оркестрація',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Інструменти Atlassian',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'З березня 2026 року',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'Розробка ШІ-агентів, налаштування робочих процесів та інтеграція інструментів.',
        'Адаптація LLM, навчання та оцінювання моделей.',
        'Розробка та інтеграція застосунків на основі ШІ.',
        'Квантові обчислення: участь у розробці програмного забезпечення для квантових застосунків.'
      ]
    },
    {
      period: 'З травня 2025 року',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'Розробка застосунків.',
        'Реалізація модульних тестів і UI-тестів для підтримки якості застосунків.'
      ]
    },
    {
      period: 'Листопад 2022 - лютий 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Супровід і вдосконалення конвеєрів даних та оркестрації робочих процесів.',
        'Розробка пакетів для автоматизації звітності.'
      ]
    },
    {
      period: 'Липень 2022 - жовтень 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Розробка та супровід ETL-конвеєрів.'
      ]
    },
    {
      period: 'Березень 2022 - червень 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Проєктування та розробка REST API і бекенд-сервісів.',
        'Реалізація бекенд-логіки для обробки JSON.'
      ]
    },
    {
      period: 'Листопад 2020 - березень 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Проєктування та розробка REST API і бекенд-сервісів (proof of concept).',
        'Розробка та супровід ETL-конвеєрів.',
        'Модернізація локальних (on-premise) застосунків шляхом міграції до AWS і переписування коду з R на Python.',
        'Валідація XML і перетворення на HTML.',
        'Розробка вебзастосунків.'
      ]
    },
    {
      period: 'Травень 2020 - листопад 2020',
      title: 'Data Scientist, PSI Polska, Познань',
      description: [
        'Проєктування та розробка REST API і бекенд-сервісів із моделлю машинного навчання на бекенді.',
        'Розробка моделі сегментації клієнтів.'
      ]
    },
    {
      period: 'Січень 2019 - квітень 2020',
      title: 'Advanced Data Scientist, Analyx, Познань',
      description: [
        'Вебскрейпінг і розробка пайплайнів даних.',
        'Розробка вебзастосунків.',
        'Моделювання маркетинг-міксу.',
        'Оптимізація робочих процесів.'
      ]
    },
    {
      period: 'Травень 2018 - грудень 2018',
      title: 'Data Scientist, Познань',
      description: [
        'Розробка ETL-процесу.',
        'Супровід Bash-скриптів.',
        'Підтримка клієнтів і аналіз ad hoc.'
      ]
    },
    {
      period: 'Квітень 2017 - квітень 2018',
      title: 'Junior Analyst, Познань',
      description: [
        'Аналіз даних і створення звітів.',
        'Підготовка документації та презентацій.'
      ]
    }
  ]
};
